import { render } from "./viewEtatEmp.vue?vue&type=template&id=4b99087f"
import script from "./viewEtatEmp.vue?vue&type=script&lang=ts"
export * from "./viewEtatEmp.vue?vue&type=script&lang=ts"
script.render = render

export default script